import * as d3 from "d3";
import tooltip from "d3-tip";
import {
  getChartDataSet,
  getNoDataFoundLabel
} from "../../../utils/graph_service";
import { groupBarChartUtility } from "./groupBarChartUtility";
function arcChartUtility(
  chartConfig,
  isDonut,
  divId,
  onDrillDown,
  drillDownConfig,
  level,
  allowDrillDown
) {
  RenderChart();

  // const pie = d3.pie().padAngle(padAngle);

  /** Render chart */
  function RenderChart() {
    //console.log("here", drillDownConfig.isDrillDown, drillDownConfig.key);
    if (drillDownConfig.isDrillDown && allowDrillDown == true) {
      const drillDownColumnsConfig = { ...chartConfig.configuration };
      const filters = [];
      if (chartConfig.configuration.isRepeated == true) {
        filters.push({
          key: chartConfig.configuration.autoGenerate.key,
          values: [drillDownConfig.config.find(x => x.level == level + 1).key]
        });
        drillDownColumnsConfig.autoGenerate.filters = filters;
      } else {
        drillDownColumnsConfig.columns = [
          chartConfig.configuration.columns.find(
            x =>
              x.name ==
              [drillDownConfig.config.find(x => x.level == level + 1).key]
          )
        ];
      }
      const resData = getChartDataSet(
				chartConfig,
				drillDownConfig,
				drillDownColumnsConfig
			);
      
      if (drillDownConfig.currentLevel == level + 1) {
        drillDownConfig.isDrillDown = false;
      }
      // console.log("here resData", resData);
      const config = {
        startDate: chartConfig.startDate,
        endDate: chartConfig.endDate,
        configuration: drillDownColumnsConfig,
        rawData: chartConfig.rawData,
        data: resData.data,
        yAxisLabel: "count",
        type: "GroupBarChart",
        keys: resData.barKeys,
        colors: resData.barColors,
        accessor: resData.chartAccessor.mainAccessor
      };
      groupBarChartUtility(
        config,
        divId,
        onDrillDown,
        drillDownConfig,
        level + 1,
        allowDrillDown
      );
    } else {
      return generateArcChart(
        chartConfig.data,
        chartConfig.colors,
        isDonut,
        divId
      );
    }
  }

  /** comma seperated numbers */
  function numberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /** Generate arc chart */
  function generateArcChart(data, colors, isDonut, divId) {
    if (!data) return;
    let width = 300;
    let height = 300;
    const node = document.getElementById(divId);

    const windowWidth = node.offsetWidth;
    let legendFont = "0.767rem";
    if (data.length > 10) {
      legendFont = "0.467rem";
    }
    if (windowWidth > width) {
      width = windowWidth - 40;
      height = windowWidth / 2 > height ? windowWidth / 2 : height;
    }

    const margin = 40;
    const radius = Math.min(width, height) / 2 - margin;

    document.querySelectorAll(".tooltip" + divId).forEach(function(a) {
      a.remove();
    });
    if (node !== null) {
      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }
    }

    const svgContainer = d3
      .select(node)
      .append("svg")
      .attr("viewBox", [
        -width / 2,
        -(height / 2) + margin + (isDonut == true ? 20 : 0),
        width,
        height + (isDonut == true ? 20 : 0)
      ])
      .attr("preserveAspectRatio", "xMinYMin");
    const svg = svgContainer.append("g");
    // .attr("transform", `translate(${width / 2}, ${width/2})`);

    totalCount = 0;
    data.forEach(function(d) {
      totalCount += parseFloat(d.attributeValue).toFixed(2);
      return d;
    });

    object = ((chartConfig || {}).rawData || [])[0];
    if (
      chartConfig.rawData?.length == 1 &&
      (object[(Object.keys(object) || [])[0]] == undefined ||
        object[(Object.keys(object) || [])[0]] == null)
    ) {
      totalCount = 0;
    }

    if (totalCount == 0) {
      getNoDataFoundLabel(
        chartConfig.startDate + " to " + chartConfig.endDate,
        svg,
        10,
        10
      );
      return;
    }
    const color = d3.scaleOrdinal(colors);
    const pie = d3
      .pie()
      .padAngle(isDonut ? 0.02 : 0)
      .value(d => parseFloat(d.attributeValue).toFixed(2))
      .sort(null);

    let innerRadius = 0;
    let outerRadius = 0;
    // let outerInnerRadius = 0;
    // let outerOuterRadius = 0;
    if (isDonut === true) {
      innerRadius = radius * 0.5;
      outerRadius = radius * 0.8;

      // outerInnerRadius = radius * 0.5;
      // outerOuterRadius = radius * 0.5;
    } else {
      outerRadius = radius - radius / 10;
      // outerInnerRadius = radius + 10;
      // outerOuterRadius = radius;
    }
    const arc = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius);

    // const outerArc = d3
    //   .arc()
    //   .innerRadius(outerInnerRadius)
    //   .outerRadius(outerOuterRadius);

    const tip = tooltip()
      .attr("class", "d3-tip tooltip" + divId)
      .html(function(d) {
        return (
          d?.data?.attributeName +
          " count " +
          numberWithCommas(d?.data?.attributeValue)
        );
      });
    svg.call(tip);

    let totalCount = 0;
    data.forEach(function(d) {
      totalCount += parseFloat(d.attributeValue);
      return d;
    });
    let object = ((chartConfig || {}).rawData || [])[0];
    if (
      chartConfig.rawData?.length == 1 &&
      (object[(Object.keys(object) || [])[0]] == undefined ||
        object[(Object.keys(object) || [])[0]] == null)
    ) {
      totalCount = 0;
    }
    if (totalCount == 0) {
      getNoDataFoundLabel(
        chartConfig.startDate + " to " + chartConfig.endDate,
        svg,
        10,
        10
      );
    } else {
      svg
        .selectAll("path")
        .data(pie(data))
        .enter()
        .append("path")
        .attr("d", arc)
        .attr("fill", (d, i) => color(i))
        .style("cursor", "pointer")
        .attr("class", "arc-container-path")
        //.on("mouseover", tip.show)
        .on("mouseover", function(d) {
          tip.show(d, this);
          d3.selectAll(".arc-container-path")
            .transition()
            .duration(200)
            .style("opacity", 0.5);

          d3.selectAll(".legend" + divId)
            .transition()
            .duration(200)
            .style("opacity", 0.5);

          d3.selectAll("." + d.data.attributeName.replace(/[^a-zA-Z0-9]/g, ""))
            .transition()
            .duration(200)
            .style("opacity", 1)
            .style("font-size", legendFont)
            .style("stroke-width", "2.5px");

          d3.select(this)
            .transition()
            .duration(200)
            .style("opacity", 1)
            .style("stroke-width", "2.5px");
        })
        .on("mouseout", function() {
          // svg.select(".title-text").remove();
          tip.hide();
          d3.selectAll(".legend" + divId)
            .transition()
            .duration(200)
            .style("opacity", 1)
            .style("font-size", legendFont)
            .style("stroke-width", "2.5px");
          d3.selectAll(".arc-container-path")
            .transition()
            .duration(200)
            .style("opacity", 1)
            .style("stroke-width", "1.5px");
        })
        .on("click", function(d) {
          tip.hide();
          onDrillDown(
            true,
            d.data.attributeName,
            chartConfig.accessor,
            "",
            level + 1
          );
        });

      svg.append("g").classed("percentage", true);

      svg
        .select(".percentage")
        .selectAll("text")
        .data(pie(data))
        .enter()
        .append("text")
        .text(function(d) {
          return d?.data?.percentage>0?`${
            isNaN(d.data.percentage) == true ? "0" : d.data.percentage
          }%`:"";
        })
        .attr("transform", function(d) {
          const pos = arc.centroid(d);
          return `translate(${pos})`;
        })
        .style("text-anchor", "middle")
        .style("font-size", "10px");
    }

    const svgSize = svg.node().getBBox();
    let legendLine = (totalCount>0? svgSize.height / 2 :((height/2)-80)) + 10;
    let currentX = -width / 2 + 20;
    const legend = svgContainer
      .append("g")
      .attr("class", "legend-container")
      .attr("x", -width / 2 + 20)
      //   .attr("y", height/2)
      .attr("width", width - 80);
    //   .attr(
    //     "transform",
    //     "translate(" + -0 + ", " + (width - (margin * 2 + 20)) + ")"
    //   );
    legend
      .selectAll("g")
      .data(data)
      .enter()
      .append("g")
      .each(function(d, i) {
        const g = d3.select(this);
        let y = legendLine;
        const rect = g
          .append("rect")
          .attr("y", y)
          .attr("x", currentX)
          .attr("width", 10)
          .attr("height", 10)
          .attr(
            "class",
            d.attributeName.replace(/[^a-zA-Z0-9]/g, "") + " legend" + divId
          )
          .style("fill", colors[i]);
        const size = rect.node().getBBox();
        currentX += size.width + 10;
        if (currentX > width / 2) {
          currentX = -width / 2 + 20;
          legendLine += 20;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
        }
        const recText = g
          .append("text")
          .attr("y", y + 10)
          .attr("x", currentX)
          .attr("height", 20)
          .attr("width", 170)
          .attr(
            "class",
            d.attributeName.replace(/[^a-zA-Z0-9]/g, "") + " legend" + divId
          )
          .style("fill", colors[i])
          .style("font-family", "roboto")
          .style("font-weight", "500")
          .style("font-size", legendFont)
          .text(function(d) {
            return (
              d.attributeName +
              " (" +
              (parseInt(totalCount) > 0
                ? numberWithCommas(parseFloat(d?.attributeValue))
                : 0) +
              ")"
            );
          });
        const recTextSize = recText.node().getBBox();
        currentX += recTextSize.width + 10;
        if (currentX > width / 2) {
          currentX = -width / 2 + 20;
          legendLine += 20;
          y = legendLine;
          rect.attr("x", currentX).attr("y", y);
          currentX += size.width + 10;
          recText.attr("x", currentX).attr("y", y + 10);
          currentX += recTextSize.width + 10;
        }
        // console.log(size, recTextSize, d);
      });

    //  svgContainer.attr("height",svgSize.height+legendSize.height+20)
    //svgContainer.attr("width",svgSize.width*10);
    
  }
}

export { arcChartUtility };
